module.exports = __webpack_public_path__ + "img/notes-icon.c34b1b0e.png";